import { styled, Typography } from "@mui/material";
import { UserPopUpContainer, UserPopUpTitle } from "./VerifyEmailFormPopUp";
import { useTranslation } from "../../helpers/i18n";

const StyledDescription = styled(Typography)(() => ({
  textAlign: "left",
  marginBottom: "1rem",
}));

const CommunityAccessPopUp = () => {
  const { t } = useTranslation();
  return (
    <UserPopUpContainer>
      <UserPopUpTitle variant="h6">
        {t("information_account_under_review")}
      </UserPopUpTitle>
      <StyledDescription>{t("information_access_requested")}</StyledDescription>
    </UserPopUpContainer>
  );
};

export default CommunityAccessPopUp;
